<template>
  <canvas width="100%" height="275"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    labels: {
      type: Array,
      default: []
    },
    values: {
      type: Array,
      default: []
    }
  },
  mounted() {
    let chartData = {
      datasets: [
        {
          data: this.values,
          backgroundColor: "#E68B3A"
        }
      ],

      // These labels appear in the legend and in the tooltips when hovering different arcs
      labels: this.labels
    };

    new Chart(this.$el.getContext("2d"), {
      type: "bar",
      data: chartData,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          position: "right"
        },
        tooltips: {
          enabled: true
        },
        cutoutPercentage: 40,
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        legend: {
          display: false
        }
      }
    });
  }
};
</script>